import { Component, inject } from '@angular/core';
import { KENDO_FILTER } from "@progress/kendo-angular-filter";
import { CompositeFilterDescriptor } from "@progress/kendo-data-query";
import { AddDashboardDialogService } from '../add-dashboard.dialog.service';


@Component({
	selector: 'add-dashboard-step-3',
	standalone: true,
	imports: [KENDO_FILTER],
	templateUrl: './add-dashboard-step-3.part.html',
	styleUrl: './add-dashboard-step-3.part.scss',
})

export class AddDashboardStep3Part {

	public service = inject(AddDashboardDialogService);

	public initialValue: CompositeFilterDescriptor = {
		logic: "and",
		filters: [],
	};

	onFilterChange(value: CompositeFilterDescriptor): void {
		this.service.setFilters(value);
	}

}